


























































































































import {PullRefresh, Overlay, Toast, Popup, List} from "vant";
import {formatDate} from "@/utils/date";
import { myTransactionSocket } from "@/views/h5-page/mixins/myTransactionSocket";

export default {
  mixins: [myTransactionSocket],
  components: {
    [Overlay.name]: Overlay,
    [PullRefresh.name]: PullRefresh,
    [Popup.name]: Popup,
    [List.name]: List
  },
  props: {
    // 查询参数：下单方式
    queryParem: {
      type: Object,
      default: {}
    },
    // Tab选中标签
    activeTab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      refreshing: false,

      // van-list,*******************Start
      loading: false,
      finished: false,
      list: [],
      // van-list,*******************End

      tableData: [],
      totalNum: 0,
      listParem: {
        page: 0,
        size: 1000,
        account_nos: (this as any).queryParem.account || ''
      },
      // **********************************************************New Start
      isScroll: false,
      tableMouseObj: {
        isDragging: false,
        startX: 0,
        startScrollLeft: 0
      }
      // **********************************************************New End
    };
  },
  watch: {
    queryParem: {
      handler(val) {
        (this as any).listParem.account_nos = val.account || '';
        if ((this as any).activeTab === 2) {
          (this as any).refreshing = true;
          (this as any).onRefresh();
        }

      },
      deep: true
    },
    activeTab: {
      handler(val) {
        clearTimeout((this as any).timer);
        if (val === 2) {
          (this as any).refreshing = true;
          (this as any).onRefresh();
        }
      },
      deep: true
    }
  },
  filters: {
    dateStr(val) {
      return formatDate(new Date(val), "MM/dd");
    },
    timeStr(val) {
      return formatDate(new Date(val), "hh:mm:ss");
    },
  },
  created() {
    const _this = this as any;
    _this.onLoad();
  },
  mounted() {
    const _window = (window as any);
    const _this = (this as any);
    _this.visibilityFn = (e) => {
      if(e.target.visibilityState == 'hidden'){
        clearTimeout(_this.timer);
      }else{
        if((this as any).activeTab === 2){
          clearTimeout(_this.timer);
          _this.onRefresh();
        }
      }
    };
    _window.addEventListener('visibilitychange', _this.visibilityFn);
  },

  methods: {
    tableScroll(e) {
      if ((this as any).$refs['tableList'].scrollLeft == 0) {
        //滚动至最左边触发
        (this as any).isScroll = false;
      } else {
        (this as any).isScroll = true;
      }
    },
    mySocketOnMsg(msg) {
      const _this = (this as any);
      if (_this.activeTab == 2) {
        clearTimeout(_this.timer);
        _this.onRefresh();
      }
    },

    async getListNew(){
      await (this as any).getList();
      clearTimeout((this as any).timer);
      if(localStorage.getItem('token')){
        (this as any).timer = setTimeout(() => {
          (this as any).getListNew();
        }, 10000);
      }
    },

    async getList() {
      let tableData: any = [];
      if (!(this as any).queryParem.account) {
        return
      }
      (this as any).socketTransaction((this as any).queryParem.account, ()=>{
        (this as any).mySocketOnMsg()
      });
      await (this as any).$apis
          .querybatchfill((this as any).listParem, {'X-channel-id': (this as any).queryParem.type})
          .then(respond => {
            let res = {data: respond};
            (this as any).totalNum = res.data.total;
            res.data.fill_infos && res.data.fill_infos.forEach(item => {
              tableData.push(item)
            });
            (this as any).tableData = tableData;
            if ((this as any).tableData.length >= (this as any).totalNum) {
              (this as any).finished = true;
            }
          })
          .catch(e => {
            
          });
    },
    async onLoad() {
      const _this = this as any;
      // const box: any = document.getElementById("app");
      // if (box.scrollTo) {
      //   box.scrollTo(0, 250)
      // } else {
      //   box.scrollTop = 0
      // }

      _this.loading = true;
        // (this as any).listParem.page++;
        await _this.getListNew();
      _this.loading = false;
    },
    async onRefresh() {
      // 在触发@refresh="onRefresh"时，_this.refreshing = true;

      const _this = (this as any);
      _this.restDataForRefreshing();

      await _this.onLoad();
      _this.refreshing = false;
    },
    notifyNewOrder(){
      (this as any).refreshing = true;
      (this as any).onRefresh();
    },
    /**
     * @Description PC端兼容滑动 tableMouseDown、tableMouseMove、tableMouseUp、allTableMouseMove、allTableMouseUp
     * @date 2024/1/8
     * @param
     * @return {void}
     */
    tableMouseDown(e,mouseObj,refStr){
      let _this = (this as any);
      mouseObj.isDragging = true;
      mouseObj.startX = e.clientX;
      mouseObj.startScrollLeft = _this.$refs[refStr].scrollLeft;
    },
    tableMouseMove(e,mouseObj,refStr){
      let _this = (this as any);
      if (mouseObj.isDragging) {
        const deltaX = e.clientX - mouseObj.startX;
        _this.$refs[refStr].scrollLeft = mouseObj.startScrollLeft - deltaX;
      }
    },
    tableMouseUp(e,mouseObj){
      mouseObj.isDragging = false;
    },
    allTableMouseMove(e){
      let _this = (this as any);
      _this.tableMouseMove(e,_this.tableMouseObj,'tableList');
    },
    allTableMouseUp(e){
      let _this = (this as any);
      _this.tableMouseUp(e,_this.tableMouseObj);
    },
    allTableMouseLeave(e){
      let _this = (this as any);
      _this.tableMouseUp(e,_this.tableMouseObj);
    },
    /**
     * @Description 重新刷新前的准备动作，
     * @date 2024/1/16
     * @return {void}
     */
    restDataForRefreshing() {
      let _this = (this as any);

      // van-list相关数据
      _this.finished = false;

      // 列表相关数据
      _this.tableData = [];

      // 分页请求相关数据
      _this.listParem.page = 0;
      _this.totalNum = 0;
    }
  },
  destroyed() {
    clearTimeout((this as any).timer);
    (window as any).removeEventListener('visibilitychange', (this as any).visibilityFn);
  }
};
